import PropTypes from "prop-types";
import React from "react";
import { getUniqueCategories, getUniqueTags, getUniqueColors, getProductsUniqueSizes } from "./utils";
import ShopSearch from "./ShopSearch";
import ShopCategories from "./ShopCategories";
import ShopColor from "./ShopColor";
import ShopSize from "./ShopSize";
// import ShopTag from "../../components/product/ShopTag";

const ShopSidebar = ({ products, getSortParams, sideSpaceClass }) => {
    const uniqueCategories = getUniqueCategories(products);
    const uniqueColors = getUniqueColors(products);
    const uniqueSizes = getProductsUniqueSizes(products);
    //   const uniqueTags = getUniqueTags(products);

    return (
        <div className={`sidebar-style ${sideSpaceClass ? sideSpaceClass : ""}`}>
            {/* shop search */}
            <ShopSearch />

            {/* filter by categories */}
            <ShopCategories categories={uniqueCategories} getSortParams={getSortParams} />

            {/* filter by color */}
            <ShopColor colors={uniqueColors} getSortParams={getSortParams} />

            {/* filter by size */}
            <ShopSize sizes={uniqueSizes} getSortParams={getSortParams} />

            {/* filter by tag */}
            {/* <ShopTag tags={uniqueTags} getSortParams={getSortParams} /> */}
        </div>
    );
};

ShopSidebar.propTypes = {
    getSortParams: PropTypes.func,
    products: PropTypes.array,
    sideSpaceClass: PropTypes.string,
};

export default ShopSidebar;
